<div class="tpr-peers">
  <div class="content">
    <div class="top-action-section">
      <div class="filter-container">
        <app-tpr-peers-filter
          class="tpr-filter"
          [suggestedPeers]="suggestedPeers"
          [primaryTicker]="primaryTicker"
          [state]="state"
          [recentlyVisitedCompanies]="recentlyVisitedCompanies"
          [watchlistData]="watchlistData"
          [isMetaReady]="isMetaReady"
          [isUserSettingsInProgress]="isUserSettingsInProgress"
          [isWatchListAndRecentCompDataReady]="
            isWatchListAndRecentCompDataReady
          "
          [isTprColumnDetailsSaveApiInProgress]="
            isTprColumnDetailsSaveApiInProgress
          "
          [columnPickerData]="columnPickerData"
          [tprVsPeersColumnPickerItem]="tprVsPeersColumnPickerItem"
          [columnPickerSelectedColumns]="columnPickerSelectedColumns"
          [columnPickerAvailableColumns]="columnPickerAvailableColumns"
          (onPeersChange)="onPeerChange($event)"
          (onCurrencyChange)="onCurrencyChange($event)"
          (updatePricePerformance)="onPricePerformanceChange($event)"
          (onColumnPickerChange)="updateColumnPicker($event)"
          (showSnackBarMessage)="showSnackBarToastMessage($event)"
        >
        </app-tpr-peers-filter>
      </div>
      <div class="cta-right-section"></div>
    </div>
    <app-tpr-peers-grid-wrapper
      [primaryTicker]="primaryTicker"
      [meta]="meta"
      [isMetaInProgress]="isMetaInProgress"
      (onDeleteTicker)="handleDeleteTicker($event)"
      [isTabVisible]="isPeerTabVisible"
    ></app-tpr-peers-grid-wrapper>
  </div>
  <div class="factset-message">
    {{ factsetCopyRightMessage }}
  </div>
</div>

<!-- Snackbar -->
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon
      name="check"
      class="snack-icon snack-success-icon"
      size="small"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon
      name="close-circle"
      class="snack-icon snack-failure-icon"
      size="small"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon
      name="info-circle"
      class="snack-icon snack-info-icon"
      size="small"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
